import type { AzureSettings } from '../services/ai-settings-api';
import { inferAzureApi, type AzureForm } from './form-rules';

export const emptyAzureForm = (saved: AzureSettings | null): AzureForm => ({
  endpoint: '',
  model: saved?.model ?? '',
  api: saved?.api ?? 'chat-completions',
  authType: saved?.authType ?? 'api-key',
  tenantId: saved?.tenantId ?? '',
  clientId: saved?.clientId ?? '',
  secret: '',
});

/**
 * Aplica un cambio de endpoint o despliegue. La API solo cambia sola cuando el cambio
 * altera la deduccion (por ejemplo, de `gpt-...` a `claude-...`): una eleccion manual se
 * respeta mientras se sigue escribiendo.
 */
export function withAzureTarget(
  form: AzureForm,
  change: Partial<Pick<AzureForm, 'endpoint' | 'model'>>,
): AzureForm {
  const next = { ...form, ...change };
  const before = inferAzureApi(form.endpoint, form.model);
  const after = inferAzureApi(next.endpoint, next.model);
  return before === after ? next : { ...next, api: after };
}

/** Igual que el servidor: la credencial guardada solo sirve si no cambia el destino. */
export function azureSecretRequired(
  form: AzureForm,
  saved: AzureSettings | null,
  host: string | null,
): boolean {
  if (!saved?.secretConfigured) return true;
  if (form.authType !== saved.authType || host !== saved.host) return true;
  return (
    form.authType === 'entra-sp' &&
    (form.tenantId.trim() !== (saved.tenantId ?? '') ||
      form.clientId.trim() !== (saved.clientId ?? ''))
  );
}
